import useAuth from '@/auth/useAuth';
import LinkService from './LinkService';
import OverviewVisualization from './visualization';
import siteConfig from '@/config';
import Changelog from './changelog';
import { Separator } from '@/components/ui/separator';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { useQuery } from '@tanstack/react-query';
import {
  useIsActiveClaimDailyFreeCredit,
} from '@/service/payment/hook';
import { Link } from 'react-router-dom';
import PATH_PAGE from '@/router/path';
import { Coins } from 'lucide-react';

// import { SiteConfigService } from '@/types/config';

const DashboardOverview: React.FC = () => {
  // const user = useGetUser()?.data;
  // const { workspaceId } = useParamWorkspaceId();
  const { session } = useAuth();
  const { services } = siteConfig;

  const isActiveClaimDailyFreeCredit = useIsActiveClaimDailyFreeCredit();

  return (
    <div className="container mt-8">
      <p className="text-2xl font-medium">Welcome</p>
      <p className="text-base text-muted-foreground">{session?.user?.email}</p>

      <div className="mt-12 flex flex-col gap-12">
        {isActiveClaimDailyFreeCredit && (
          <Alert variant={'info'}>
            <Coins className="h-4 w-4" />
            <AlertTitle>🎁 Claim Daily Free Credit</AlertTitle>
            <AlertDescription>
              You can claim daily free credit. Go to{' '}
              <Link
                to={PATH_PAGE.setting.payment}
                className="font-bold underline"
              >
                Payment
              </Link>{' '}
              to claim.
            </AlertDescription>
          </Alert>
        )}
        <LinkService />
        {siteConfig.services.llm && <OverviewVisualization />}
      </div>
      <Separator className="mt-12" />
      <section className="py-12">
        <Changelog />
      </section>
    </div>
  );
};

export default DashboardOverview;
